import { menuPreviewRoutes } from '@menuPreview/routes';
import { productMasterRoutes } from '@productMaster/routes';
import { eventManagerRoutes } from '@eventManager/routes';
import { socialMediaRoutes } from '@socialMedia/routes';
import { pointOfSaleRoutes } from './views/pointOfSale/routes';
import Dynameat from './Dynameat.vue';
import { dashboardRoutes } from './views/dashboard/routes';
import { profileRoutes } from './views/profile/routes';
import { userManagerRoutes } from './views/userManager/routes';

export const dynameatRoutes = [
  {
    path: '/',
    component: Dynameat,
    meta: { requiresAuth: true },
    children: [
      ...dashboardRoutes,
      ...profileRoutes,
      ...userManagerRoutes,
      ...productMasterRoutes,
      ...eventManagerRoutes,
      ...socialMediaRoutes
    ]
  },
  {
    path: '/:pointOfSaleGuid',
    component: Dynameat,
    meta: { requiresAuth: true },
    children: [
      ...pointOfSaleRoutes
    ],
  },
  ...menuPreviewRoutes
];
